module.exports = {
  acceptedPaymentMethods: 'Accepted Payment Methods',
  'credit-card': 'Credit Card',
  'gift-card': 'Gift Card',
  paypal: 'Paypal',
  affirm: 'Affirm',
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/translations/accepted_payment_methods/en.js